"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var __jsx = _react["default"].createElement;
var CloseIcon = function CloseIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var defaultProps = {
  defaultNotification: true,
  additionalHtml: "",
  forceBgColor: "",
  fonts: {
    small: "s_sans_bold",
    normal: "base_sans_bold"
  }
};
var Notification = function Notification(props) {
  var message = props.message,
    messageButton = props.messageButton,
    messageButtonLabel = props.messageButtonLabel,
    onMessageButtonClick = props.onMessageButtonClick,
    closeButton = props.closeButton,
    closeButtonLabel = props.closeButtonLabel,
    onCloseClick = props.onCloseClick,
    _props$defaultNotific = props.defaultNotification,
    defaultNotification = _props$defaultNotific === void 0 ? defaultProps.defaultNotification : _props$defaultNotific,
    isError = props.isError,
    onClick = props.onClick,
    _props$additionalHtml = props.additionalHtml,
    additionalHtml = _props$additionalHtml === void 0 ? defaultProps.additionalHtml : _props$additionalHtml,
    _props$forceBgColor = props.forceBgColor,
    forceBgColor = _props$forceBgColor === void 0 ? defaultProps.forceBgColor : _props$forceBgColor,
    _props$fonts = props.fonts,
    fonts = _props$fonts === void 0 ? defaultProps.fonts : _props$fonts;
  var ActionButton = messageButton ? /*#__PURE__*/_react["default"].cloneElement(messageButton, {
    onClick: function onClick() {
      return onMessageButtonClick();
    }
  }, messageButtonLabel) : "";
  var QuitButton = closeButton ? /*#__PURE__*/_react["default"].cloneElement(closeButton, {
    onClick: function onClick() {
      return onCloseClick();
    }
  }, closeButtonLabel) : "";
  return __jsx(_Box["default"], {
    sx: {
      borderRadius: "4px",
      bg: forceBgColor ? forceBgColor : defaultNotification ? "main" : isError ? "main" : "positive500",
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
      py: ["s6", null, null, "s9"],
      px: ["s8", null, null, "s10"]
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      color: "white",
      mb: ActionButton || QuitButton ? "s6" : 0,
      font: [fonts.small, null, null, fonts.normal]
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      position: "absolute",
      top: 5,
      right: "s4",
      cursor: "pointer",
      width: 20,
      height: 20,
      svg: {
        fill: "white",
        width: 20,
        height: 20
      }
    },
    onClick: onClick
  }, __jsx(CloseIcon, null)), message), (ActionButton || QuitButton) && __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexWrap: "nowrap",
      justifyContent: "space-between"
    }
  }, ActionButton && __jsx(_Box["default"], null, ActionButton), QuitButton && __jsx(_Box["default"], null, QuitButton)), __jsx(_Box["default"], {
    dangerouslySetInnerHTML: {
      __html: additionalHtml
    }
  }));
};
var _default = Notification;
exports["default"] = _default;